import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../pages/user-panel/auth.service';
import { environment } from 'src/environments/environment';
import { UserService } from '../../panel/user/users.service';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class PanelProfileComponent implements OnInit {
  private baseUrl = environment.apiUrl;

  constructor(private authService:AuthService, private userService:UserService) {}
  data: any = {}

  ngOnInit(): void {
    this.userService.getUserByToken().subscribe((response) => {
      this.data = response;
      const image=  this.baseUrl+ this.data.imageUrl
      this.data.imageUrl = image;
    });
  }


  logout() {
    this.authService.logout();
  }

}
